<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: ITAT ID      

========================================================================================== -->


<template>
    <div id="currentTimeEntry" v-if="!isClient && showCurrentTimeEntry && !isEveryone">
      
      <!-- CURRENT TIME ENTRY -->
      <div class="vx-row mx-5">

          <div class="vx-col w-full mt-8">
            <div class="vx-row">
              <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-5/12">
                <transition name="fade" mode="out-in">
                  <!-- <div :key="taskNameByID"> -->

                    <vx-card style="height:100%; overflow: hidden;">
                      <div class="pausedOverlay"  v-if="subTimeEntry != null">
                        <h3 style="text-align: center; margin-top: 50px;">PAUSED</h3>
                      </div>
                      <div :class="{lowOpacity: subTimeEntry != null}">
                        <div class="flex flex-inline mb-4">
                          <h5> {{taskNameByID}}</h5>
                        </div>
                        <vs-button v-show="currentTimeEntry != null" @click="OnClickClockOut" id="clockOutButton" color='primary' icon="timer" style="position: absolute; right: 20px; bottom: 27px;">Clock Out</vs-button>

                        <vs-progress :percent="currentTaskProgress" style="position: absolute; top: 0px; left: 0px; right: 0px;" :color="currentTaskColor"></vs-progress>
                        <div v-show="currentTimeEntry != null">
                          
                          
                          <div class="">
                            <b>Client: </b><span class="currentTimeEntryColored">{{clientNameByID}}</span>
                          </div>
                          <div class="">
                            <b>Category: </b><span class="currentTimeEntryColored">{{categoryNameByID}}</span>
                          </div>
                          <!-- <div class="">
                            <b>Project: </b><span class="currentTimeEntryColored"> {{projectNameByID}}</span>
                          </div> -->
                          <div v-if="taskNameByID !== 'No Associated Task'">
                            <span>{{ currentTaskDelta }} out of {{currentTaskTimeEstimate}} hours</span>
                          </div>
                        </div>
                      </div>

                    </vx-card>
                <!-- </div> -->
                </transition>
              </div>

              <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-7/12">
            <vx-card style="min-height: 169px;">
              <!-- {{ billableWeeklyWorked }} -->
             
              <div class="pie-charts-holder">
                <div class="pie-chart-col">
                  <div class="currentTimeChart"> <!--  v-if="totalHoursWorkedSum !='0.0'" -->
                    <div class="billableTarget" :style="{ transform: 'translate(-50%, -50%) rotate(' + (billableWeeklyWorked.BillablePercentGoal * 360 - 270).toString() + 'deg) translateX(-70px)' }">Target</div>
                    <feather-icon icon="AwardIcon" v-if="overBillable" svgClasses="h-12 w-12" class="hoursReward" />
                    <div class="hoursWorkedChartTitle">Billable</div>
                    <div class="hoursWorkedChartBottomTitle">Week</div>
                    <div class="hoursWorkedChartLabel" v-if="!overBillable">{{ billableWeeklyWorked.BilledHours }}</div>
                    <div class="hoursWorkedChartLabel2" v-if="!overBillable">{{ billableWeeklyWorked.TotalHours }}</div>
                    <vue-apex-charts type="donut" height="125" :options="donutChartBillable.chartOptions" :series="donutChartSeriesBillable" />
                  </div>
                </div>
                <div class="pie-chart-col">
                  <div class="currentTimeChart"> <!--  v-if="totalHoursWorkedSum !='0.0'" -->
                    <div class="hoursWorkedChartTitle">Hours</div>
                    <div class="hoursWorkedChartBottomTitle">Today</div>
                    <div class="hoursWorkedChartLabel">{{totalHoursWorkedSum}}</div>
                    <div class="hoursWorkedChartLabel2">hrs</div>
                    <vue-apex-charts type="donut" height="125" :options="donutChart.chartOptions" :series="donutChartSeries" />
                  </div>
                </div>
                <div class="pie-chart-col">
                  <div class="currentTimeChart"> <!--  v-if="totalHoursWorkedSumWeekly !='0.0'" -->
                    <div class="hoursWorkedChartTitle">Hours</div>
                    <div class="hoursWorkedChartBottomTitle">Week</div>
                    <div class="hoursWorkedChartLabel">{{totalHoursWorkedSumWeekly}}</div>
                    <div class="hoursWorkedChartLabel2">hrs</div>
                      <vue-apex-charts type="donut" height="125" :options="donutChartWeekly.chartOptions" :series="donutChartSeriesWeekly" />
                  </div>
                </div>
                <div class="pie-chart-col">
                  <div class="currentTimeChart"> <!--  v-if="totalHoursWorkedSumWeekly !='0.0'" -->
                    <div class="hoursWorkedChartTitle">Mileage</div>
                    <div class="hoursWorkedChartBottomTitle">Week</div>
                    <div class="hoursWorkedChartLabel">{{ weeklyMileage }}</div>
                    <div class="hoursWorkedChartLabel2">mi</div>
                    <div class="mileage-ring-holder">
                      <div class="mileage-ring"></div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- <transition name="fade" mode="out-in">
                <div class="flex" :key="totalHoursWorkedSum">
                  <div v-if="totalHoursWorkedSum !='0.0' || currentTimeEntry != null" class="flex">
                    <h5>Time Worked</h5>
                  </div>
                  <div v-else>
                    No Time Worked Today
                  </div>
                
                </div>
              </transition> -->
            </vx-card>

            <!-- <transition name="fade" mode="out-in"> -->
                      <!-- <div :key="subEntryActiveKey">
                        <div v-if="currentTimeEntry != null">
                          <div v-if="subTimeEntry == null">
                            <div class="mt-2">
                              <vs-button size="small" color="primary" class="m-1" @click="ClockInSubEntry('meeting')">Meeting</vs-button>
                              <vs-button size="small" color="primary" class="m-1" @click="ClockInSubEntry('helping')">Helping Employee</vs-button>
                              <vs-button size="small" color="primary" class="m-1" @click="ClockInSubEntry('training')">Training</vs-button>
                            </div>
                          </div>
                          <div v-else class="mt-2">
                            <b>Client: </b><span class="currentTimeEntryColored">{{clientNameBySubID}}</span><br/>
                            <b>Category: </b><span class="currentTimeEntryColored">{{categoryNameBySubID}}</span><br/><br/>
                            <span style="font-size: 30px;">{{subEntryTime}}</span>
                            <vs-button @click="FinishSubEntry()" style="position:absolute; right: 20px; bottom: 25px;">Finish</vs-button>
                          </div>
                        </div>
                        <div v-else>
                          Clock in to access sub-entries
                        </div>
                      </div> -->
              </div>

              <!-- <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/3" style="display: none;">
                 <vx-card style="height:169px;">
                   <div>
                    <h5>Premade Entry</h5>
                    
                    <div>
                      <vs-button size="small" color="#ff9944" class="m-tiny" @click="ClockInSubEntry('morningmeeting')">Morning Meeting</vs-button>
                      <vs-button size="small" color="#ff4488" class="m-tiny" @click="ClockInSubEntry('meeting')">Meeting</vs-button>
                      <vs-button size="small" color="#cc00ff" class="m-tiny" @click="ClockInSubEntry('management')">Management</vs-button>
                      <vs-button size="small" color="#cc4466" class="m-tiny" @click="ClockInSubEntry('marketing')">Marketing</vs-button>
                      <vs-button size="small" color="#009950" class="m-tiny" @click="ClockInSubEntry('misctasks')">Misc Tasks</vs-button>
                      <vs-button size="small" color="#009999" class="m-tiny" @click="ClockInSubEntry('breaktime')">Break Time</vs-button>
                    </div>
                  </div>
                 </vx-card>
              </div> -->
            </div>
          </div>

          
          


        </div>
        <!-- END CURRENT TIME ENTRY -->

        <vs-prompt 
          color="primary"
          title="Select Worker to Help"
          @accept="HelpWorker(selectedWorkerID)"
          :active.sync="helpWorkerPromptActive">
          <v-select :options="jiraWorkerList" :reduce="x => x.ITATID" label="DropdownDisplay" v-model="selectedWorkerID" placeholder="Choose a Jira Worker" class="mt-2"/>
        </vs-prompt>

    </div>
</template>

<script>
const moment = require('moment') // require
import VueApexCharts from 'vue-apexcharts'
import Vue from 'vue'
import chartConfigs from '../../components/statistics-cards/chartConfigs'
import vSelect from 'vue-select'


export default {
  name: 'current-time-entry',
  props: {
    
  },
  components : {
    VueApexCharts,
    'v-select': vSelect
  },
  data() {
    return {
      overBillable: false,
      currentTaskDelta: 0.00,
      currentTaskProgress: 0.00,
      currentTaskColor: 'primary',
      selectedWorkerID: null,
      helpWorkerPromptActive: false,
      customers: {
        
      },
      polling1: null,
      polling2: null,
      subEntryCounting: null,
      subEntryTime: "",
      donutChartSeriesBillable : [],
      donutChartSeries : [],
      donutChartSeriesWeekly:[],
      totalHoursWorkedSum: 0,
      totalHoursWorkedSumWeekly: 0,
      legendData:['asda', 'SAda'],
      chartUpdater: 0,
      donutChartBillable: {
        chartOptions: {
          labels: [],
          dataLabels: {
            enabled: false
          },
          legend: { show: false },
          chart: {
            type: 'donut',
            offsetY: 0,
            dropShadow: {
              enabled: false,
              blur: 5,
              left: 1,
              top: 1,
              opacity: 0.2
            },
            toolbar: {
              show: false
            }
          },
          tooltip: {
            fillSeriesColor: false,
            followCursor: false,
            y: {
              formatter (val) {
                if (isNaN(val)) {
                  return val
                }
                if (val == null) {
                  return ''
                }
                // return val
                return Math.floor(val) + ":" + moment().startOf('day').add(val % 24 , 'hours').format('mm')
              }
            }
          },

          stroke: {
            width: 0
          },
          colors: ['green', 'red']
          // fill: {
          //   type: 'gradient',
          //   gradient: {
          //     gradientToColors: ['#9c8cfc00', '#FFC085', '#f29292', '#827191', '#84ACCE', '#7D1D3F']
          //   }
          // }
        }
      },
      donutChart: {
        chartOptions: {
          labels: [],
          dataLabels: {
            enabled: false
          },
          legend: { show: false },
          chart: {
            type: 'donut',
            offsetY: 0,
            dropShadow: {
              enabled: false,
              blur: 5,
              left: 1,
              top: 1,
              opacity: 0.2
            },
            toolbar: {
              show: false
            }
          },
          tooltip: {
            fillSeriesColor: false,
            followCursor: false,
            y: {
              formatter (val) {
                if (isNaN(val)) {
                  return val
                }
                if (val == null) {
                  return ''
                }
                // return val
                return Math.floor(val) + ":" + moment().startOf('day').add(val % 24 , 'hours').format('mm')
              }
            }
          },

          stroke: {
            width: 0
          },
          colors: ['#7961F911', '#FF9F43', '#EA5455', '#827191', '#84ACCE', '#7D1D3F']
          // fill: {
          //   type: 'gradient',
          //   gradient: {
          //     gradientToColors: ['#9c8cfc00', '#FFC085', '#f29292', '#827191', '#84ACCE', '#7D1D3F']
          //   }
          // }
        }
      },
      donutChartWeekly: {
        chartOptions: {
          labels: [],
          dataLabels: {
            enabled: false
          },
          legend: { show: false },
          chart: {
            type: 'donut',
            offsetY: 0,
            dropShadow: {
              enabled: false,
              blur: 5,
              left: 1,
              top: 1,
              opacity: 0.2
            },
            toolbar: {
              show: false
            }
          },
          tooltip: {
            fillSeriesColor: false,
            followCursor: false,
            y: {
              formatter (val) {
                if (isNaN(val)) {
                  return val
                }
                if (val == null) {
                  return ''
                }
                return Math.floor(val) + ":" + moment().startOf('day').add(val % 24 , 'hours').format('mm')

              }
            }
          },

          stroke: {
            width: 0
          },
          colors: ['#7961F911', '#FF9F43', '#EA5455', '#827191', '#84ACCE', '#7D1D3F']
          // fill: {
          //   type: 'gradient',
          //   gradient: {
          //     gradientToColors: ['#9c8cfc00', '#FFC085', '#f29292', '#827191', '#84ACCE', '#7D1D3F']
          //   }
          // }
        }
      }
    }
  },
  watch:{
    rawTotalHoursWorked () {
      this.BeginPolling()
    },
    rawTotalHoursWorkedWeekly () {
      this.BeginPolling()
    },
    currentTimeEntry () {
      this.BeginPolling()
    },
    billableWeeklyWorked() {
      this.UpdatePieChartBillable()
    },
    clientList () {
      this.UpdatePieChart()
      this.UpdatePieChartWeekly()
    }
  },
  computed: {
    weeklyMileage() {
      return this.$store.getters.GetWeeklyMileage
    },
    sowList() {
      const sows = this.$store.getters.GetSOWList
      return sows
    },
    billableWeeklyWorked() {
      return this.$store.getters.GetBillableWeeklyWorked
    },
    timeEntryList () {
      const list = this.$store.getters.GetTimeEntryList
      //if(this.selectedWorkerID != -1){ //Selecting a certain worker
      //return list.filter(x => x.WorkerID == this.selectedWorkerID && x.TimeOut != null)
      //}else{ //Selecting all wrkers
      return list.filter(x => x.TimeOut != null)
      //	}
    },
    ParsedTimeEntryList () {
      const list = this.timeEntryList
      const newList = []
      for (let i = 0; i < list.length; i++) {
        const entry = list[i]
        const mockEntry = {}
        let taskName = 'No Task'
        const task =  this.GetTaskByID(entry.TaskJiraID)
        if (task != null) {
          if (task.JiraIssueID != null) {
            taskName = task.fullName
          }
        }
        mockEntry.RecordID = entry.RecordID
        mockEntry.EntryDate = entry.EntryDate
        mockEntry.Note = entry.Note
        mockEntry.SortBy = entry.SortBy
        mockEntry.WorkerID = entry.WorkerID
        mockEntry.JiraIssueID = entry.JiraIssueID
        mockEntry.TimeIn = entry.TimeIn
        mockEntry.TimeOut = entry.TimeOut
        mockEntry.ProjectID = entry.ProjectID
        mockEntry.ClientID = entry.ClientID
        mockEntry.WorkerName = entry.WorkerName
        mockEntry.ClientName = (this.GetClientByID(entry.ClientID) || {}).ClientName || '-'
        mockEntry.CategoryName = this.GetCategoryByID(entry.CategoryID).CategoryName
        mockEntry.CategoryID = entry.CategoryID
        // mockEntry.ProjectName = this.GetProjectByID(entry.ProjectID).name
        mockEntry.Task = taskName
        mockEntry.EntryDateLabel = this.GetDateDay(entry.TimeIn)
        newList.push(mockEntry)
      }
      return newList
    },
    currentTimeEntryTask(){
      if(this.currentTimeEntry == null) return null
      if(this.currentTimeEntry.TaskID != null) {
        return this.taskList.find(x => x.TaskID === this.currentTimeEntry.TaskID)
      }
      if(this.currentTimeEntry.SOWLineItemID != null) {
        return this.taskList.find(x => x.SOWLineItemID === this.currentTimeEntry.SOWLineItemID)
      }
      return null
    },
    currentTaskTimeEstimate() {
      if(this.currentTimeEntryTask == null) return 0
      if(this.currentTimeEntryTask.TimeEstimate != null) return Number(this.currentTimeEntryTask.TimeEstimate).toFixed(2)
      var hours = this.currentTimeEntryTask.fields && this.currentTimeEntryTask.fields.timeoriginalestimate
      if(hours == null) hours = 0
      return hours.toFixed(2)
    },
    fullWorkerList () {
      return this.$store.getters.GetFullWorkerList
    },
    jiraWorkerList () {
      return (this.fullWorkerList || []).map(w => ({
        ITATID: w.WorkerID,
        DropdownDisplay: w.WorkerName || ''
      }))
    },
    subEntryActiveKey(){
      return this.subTimeEntry == null ? 0 : 1
    },
    isEveryone () {
      return this.$store.getters.GetIsEveryone
    },
    showCurrentTimeEntry () {
      return this.$route.name === 'timeEntries' || this.$route.name === 'tasks'
    },
    isClient() {
      return this.$store.getters.GetIsClient
    },
    windowWidth() {
      return this.$store.state.windowWidth
    },
    currentTimeEntry() {
      return this.$store.getters.GetCurrentTimeEntry
    },
    subTimeEntry() {
      return this.$store.getters.GetSubTimeEntry
    },
    projectList() {
      return this.$store.getters.GetProjectList
    },
    taskList() {
      return this.$store.getters.GetMyTaskListV2
    },
    categoryList() {
      return this.$store.getters.GetCategoryList
    },
    clientList() {
      return this.$store.getters.GetClientList
    },
    categoryNameBySubID() {
      const def = 'Client'

      if (this.subTimeEntry == null) return def
      const c = this.categoryList.find(x => x.CategoryID === this.subTimeEntry.CategoryID)
      if (c == null) return def

      return c.CategoryName
    },
    clientNameBySubID() {

      const def = 'Client'

      if (this.subTimeEntry == null) return def
      const c = this.clientList.find(x => x.ClientID === this.subTimeEntry.ClientID)
      if (c == null) return def
      return c.ClientName
    },
    categoryNameByID() {
      const def = 'Client'

      if (this.currentTimeEntry == null) return def
      const c = this.categoryList.find(x => x.CategoryID === this.currentTimeEntry.CategoryID)
      if (c == null) return def

      return c.CategoryName
    },
    clientNameByID() {

      const def = 'Client'

      if (this.currentTimeEntry == null) return def
      const c = this.clientList.find(x => x.ClientID === this.currentTimeEntry.ClientID)
      if (c == null) return def
      return c.ClientName
    },
    projectNameByID() {
      const def = 'Project'

      if (this.currentTimeEntry == null) return def
      const task = this.currentTimeEntryTask
      if (task == null) return def
      if (task.ProjectName != null) return task.ProjectName
      if (task.fields && task.fields.project) return task.fields.project.name
      return def
    },
    taskNameByID() {
      const def = 'No Current Task'
      if (this.currentTimeEntry == null) return def

      const t = this.currentTimeEntryTask

      if (t == null) return 'No Associated Task'

      return t.TaskName != null ? t.TaskName : (t.fullName || 'No Associated Task')
    },
    rawTotalHoursWorked() {
      return this.$store.getters.GetRawTotalHoursWorked
    },
    rawTotalHoursWorkedWeekly() {
      return this.$store.getters.GetRawTotalHoursWorkedWeekly
    },
    currentTimeEntryHours() {
      if (this.currentTimeEntry != null) {
        if (this.currentTimeEntry.ClientID != null) {
          const f = 'YYYY-MM-DD hh:mm A'
          var duration = moment.duration(moment().diff(moment(moment.utc(this.currentTimeEntry.TimeIn, f).toDate())))
          const dur = duration.asHours()
          return dur
        }
      }
      return 0
    }
  },
  methods:{
    HelpWorker(workerID){
      const w = this.jiraWorkerList.find(x => x.ITATID == workerID)
      var workerName = w ? w.DropdownDisplay : ''
      //CALL API and get current time entry for the specific worker
      this.$store.dispatch("ActionFetchWorkerCurrentTimeEntry", workerID).then(x => {
        x = x.data
        var timeEntry = x.timeEntry
        const currentTime = moment().format('hh:mm A')
        const currentDate = moment().format('Y-MM-DD')
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Clock In',
          jiraIssueID: timeEntry.JiraIssueID,
          clientName: 'ITAT Internal',
          clientID: timeEntry.ClientID,
          categoryID: timeEntry.CategoryID,
          projectID: timeEntry.ProjectID,
          startTime: currentTime,
          startDate: currentDate,
          endTime: null,
          endDate: null,
          description: 'Helping ' + workerName,
          error: 'Fields cannot be empty.',
          action: 'clockin' //create, clockin, finish
        })
      })
    },
    GetTaskByID (taskJiraID) {
      let task = this.taskList.find(x => x.id == taskJiraID)
      if (task == null) {
        task = {Task:'None'}
      }
     
      return task
    },
    GetTaskJiraIDByITATID(itatID){
      var x = this.taskList.find(x=> x.JiraIssueID == itatID)
      if(x != null)
        return x.id

      return null   
    },
    GetTaskIDByITATID(itatID){
      var x = this.taskList.find(x=> x.JiraIssueID == itatID)
      if(x != null)
        return x.JiraIssueID

      return null
    },
    GetTaskIDByJiraID(jiraID){
      var x = this.taskList.find(x=> x.id == jiraID)
      if(x != null)
        return x.JiraIssueID

      return null
    },
    GetProjectIDByITATID(itatID){
      var x = this.projectList.find(x=> x.ITATInfo.ProjectID == itatID)
      if(x != null)
        return x.ITATInfo.ProjectID

      return null
    },
     GetProjectIDByJiraID(jiraID){
      var x = this.projectList.find(x=> x.JiraInfo.id == jiraID)
      if(x != null)
        return x.ITATInfo.ProjectID

      return null
    },
    FinishSubEntry() {

      var timeInUTC = moment().utc().add(1, "hours").format()
      var newCurrent = {
        "TimeIn"				  : timeInUTC,
        "ClientID"				: this.currentTimeEntry.ClientID,
        "CategoryID"			: this.currentTimeEntry.CategoryID,
        "JiraIssueID"			: this.currentTimeEntry.JiraIssueID,
        "ProjectID"       : this.GetProjectIDByITATID(this.currentTimeEntry.ProjectID),
        "Note"					  : this.currentTimeEntry.Note,
      }
      
      //Create time entry from current.TimeIn to sub.TimeIn
      var timeInUTC = moment(moment.utc(this.currentTimeEntry.TimeIn, "YYYY-MM-DD hh:mm A").toDate()).add(1,"hours").format()
      var timeOutUTC = moment(moment.utc(this.subTimeEntry.TimeIn, "YYYY-MM-DD hh:mm A").toDate()).add(1,"hours").format()
      var obj = {
          "RecordID"        : this.currentTimeEntry.RecordID,
          "TimeIn"				  : timeInUTC,
          "TimeOut"         : timeOutUTC,
          "ClientID"				: this.currentTimeEntry.ClientID,
          "CategoryID"			: this.currentTimeEntry.CategoryID,
          "JiraIssueID"			: this.currentTimeEntry.JiraIssueID,
          "ProjectID"       : this.GetProjectIDByITATID(this.currentTimeEntry.ProjectID),
          "Note"					  : this.currentTimeEntry.Note,
          "ClockingOut"     : true
        }
      this.$store.dispatch("ActionPutTimeEntry", obj).then(response => {
        this.$store.commit("SetCurrentTimeEntry", null)
        this.$store.dispatch("ActionSetNewTimeEntry", response.data)

        //Clock out of sub time entry
      var timeInUTC = moment(moment.utc(this.subTimeEntry.TimeIn, "YYYY-MM-DD hh:mm A").toDate()).add(1,"hours").format()
      var timeOutUTC = moment().utc().add(1, "hours").format()
      this.$store.dispatch("ActionPutTimeEntry", 
        {
          "RecordID"        : this.subTimeEntry.RecordID,
          "TimeIn"				  : timeInUTC,
          "TimeOut"				  : timeOutUTC,
          "ClientID"				: this.subTimeEntry.ClientID,
          "CategoryID"			: this.subTimeEntry.CategoryID,
          // "TaskID"			    : this.subTimeEntry.JiraIssueID,
          "JiraIssueID"     : this.GetTaskJiraIDByITATID(this.subTimeEntry.JiraIssueID),
          "ProjectID"       : this.subTimeEntry.ProjectID,
          "Note"					  : this.subTimeEntry.Note,
          "ClockingOut"     : true
        }).then(response => {
          this.$store.commit("SetSubTimeEntry", null)
          this.$store.dispatch("ActionSetNewTimeEntry",response.data)
            this.$vs.notify({
            color: 'success',
            title:"Clocked Out!"
          })

           //Create new current time entry from sub.TimeOut
            this.$store.dispatch("ActionPostTimeEntry", newCurrent)
            
        })
      })
    },
    SubEntryTick() {
      if(this.subTimeEntry != null){
        const f = 'YYYY-MM-DD hh:mm A'
        const ms = moment().diff(moment(moment.utc(this.subTimeEntry.TimeIn, f).toDate()))
        const d = moment.duration(ms)
        const p = Math.floor(d.asHours()) + moment.utc(ms).format(':mm:ss')
        this.subEntryTime = p
      } else {
        this.subEntryTime = ""
      }
      if (this.currentTimeEntry != null) {
        let timespent = 0
        if (this.currentTimeEntryTask != null) {
          if (this.currentTimeEntryTask.HoursLogged != null) timespent = this.currentTimeEntryTask.HoursLogged
          else if (this.currentTimeEntryTask.fields && this.currentTimeEntryTask.fields.timespent != null) timespent = this.currentTimeEntryTask.fields.timespent
        }
        this.currentTaskDelta = (moment.duration(moment().diff(moment(moment.utc(this.currentTimeEntry.TimeIn, 'YYYY-MM-DD hh:mm A').toDate()))).asHours() + timespent)
        this.currentTaskProgress = this.currentTaskDelta / this.currentTaskTimeEstimate * 100
        if (this.currentTaskProgress > 100) {
          this.currentTaskColor = 'ea5455'
        } else {
          this.currentTaskColor = this.LerpColor('#7367f0', '#ea5455', (this.currentTaskProgress) / 80)
        }
      } else {
        this.currentTaskDelta = 0
        this.currentTaskProgress = 0
        this.currentTaskColor = 'primary'
      }
      this.currentTaskDelta = this.currentTaskDelta.toFixed(2)
    },
    ClockInSubEntry(template) {
      const currentDate = moment().format('Y-MM-DD')
      const currentTime = moment().format('hh:mm A')

      if (template == 'meeting') {
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Clock In',
          taskName: null,
          taskID: null,
          clientName: 'ITAT Internal',
          clientID: (this.clientList.find(x => x.ClientName === 'ITAT Internal') || {}).ClientID,
          categoryID: this.categoryList.find(x => x.CategoryName === 'Meeting').CategoryID,
          clientCategory: 'Client Category',
          startTime: currentTime,
          startDate: currentDate,
          endTime: null,
          endDate: null,
          description: 'Meeting with ',
          error: 'Fields cannot be empty.',
          action: 'create' //create, clockin, finish
        })
      } else if(template == 'morningmeeting') {
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Clock In',
          taskName: null,
          taskID: null,
          clientName: 'ITAT Internal',
          clientID: (this.clientList.find(x => x.ClientName === 'ITAT Internal') || {}).ClientID,
          categoryID: this.categoryList.find(x => x.CategoryName === 'Meeting').CategoryID,
          clientCategory: 'Client Category',
          startTime: '08:40 AM',
          startDate: currentDate,
          endTime: '09:00 AM',
          endDate: currentDate,
          description: 'Morning meeting',
          error: 'Fields cannot be empty.',
          action: 'create' //create, clockin, finish
        })
      } else if(template == 'management') {
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Clock In',
          taskName: null,
          taskID: null,
          clientName: 'ITAT Internal',
          clientID: (this.clientList.find(x => x.ClientName === 'ITAT Internal') || {}).ClientID,
          categoryID: this.categoryList.find(x => x.CategoryName === 'Management').CategoryID,
          clientCategory: 'Client Category',
          startTime: currentTime,
          startDate: currentDate,
          endTime: null,
          endDate: null,
          description: 'Management',
          error: 'Fields cannot be empty.',
          action: 'create' //create, clockin, finish
        })
      } else if(template == 'marketing') {
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Clock In',
          taskName: null,
          taskID: null,
          clientName: 'ITAT Internal',
          clientID: (this.clientList.find(x => x.ClientName === 'ITAT Internal') || {}).ClientID,
          categoryID: this.categoryList.find(x => x.CategoryName === 'Marketing').CategoryID,
          clientCategory: 'Client Category',
          startTime: currentTime,
          startDate: currentDate,
          endTime: null,
          endDate: null,
          description: 'Marketing',
          error: 'Fields cannot be empty.',
          action: 'create' //create, clockin, finish
        })
      } else if(template == 'misctasks') {
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Clock In',
          taskName: null,
          taskID: null,
          clientName: 'ITAT Internal',
          clientID: (this.clientList.find(x => x.ClientName === 'ITAT Internal') || {}).ClientID,
          categoryID: this.categoryList.find(x => x.CategoryName === 'Misc. Tasks').CategoryID,
          clientCategory: 'Client Category',
          startTime: currentTime,
          startDate: currentDate,
          endTime: null,
          endDate: null,
          description: '',
          error: 'Fields cannot be empty.',
          action: 'create' //create, clockin, finish
        })
      } else if(template == 'breaktime') {
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Clock In',
          taskName: null,
          taskID: null,
          clientName: 'ITAT Internal',
          clientID: (this.clientList.find(x => x.ClientName === 'ITAT Internal') || {}).ClientID,
          categoryID: this.categoryList.find(x => x.CategoryName === 'Break Time').CategoryID,
          clientCategory: 'Client Category',
          startTime: currentTime,
          startDate: currentDate,
          endTime: null,
          endDate: null,
          description: 'Break time',
          error: 'Fields cannot be empty.',
          action: 'create' //create, clockin, finish
        })
      }
    },
    GetToolTipText(indextr) {
      const hours = this.donutChartSeries[indextr]
      return moment().startOf('day').add(hours, 'hours').format('H:mm')
    },
    GetTotalHoursWorkedSum() {
      let timeWorked = 0
      for (let i = 0; i < this.rawTotalHoursWorked.length; i++) {
        timeWorked += this.rawTotalHoursWorked[i].HoursWorked
      }

      let finalHours = timeWorked

      if (this.currentTimeEntry != null) {
        if (this.currentTimeEntry.ClientID != null) {
          const f = 'YYYY-MM-DD hh:mm A'
          const duration = moment.duration(moment().diff(moment(moment.utc(this.currentTimeEntry.TimeIn, f).toDate())))
          const dur = duration.asHours()

          finalHours += dur
        }
      }
      this.totalHoursWorkedSum = moment().startOf('day').add(finalHours, 'hours').format('H:mm'); // finalHours.toFixed(1)///
    },
    GetTotalHoursWorkedSumWeekly() {
      let timeWorked = 0
      console.log('oing', this.rawTotalHoursWorkedWeekly)
      for (let i = 0; i < this.rawTotalHoursWorkedWeekly.length; i++) {
        timeWorked += this.rawTotalHoursWorkedWeekly[i].HoursWorked
      }

      let finalHours = timeWorked
      console.log('final hours week', finalHours)

      if (this.currentTimeEntry != null) {
        if (this.currentTimeEntry.ClientID != null) {
          const f = 'YYYY-MM-DD hh:mm A'
          const duration = moment.duration(moment().diff(moment(moment.utc(this.currentTimeEntry.TimeIn, f).toDate())))
          const dur = duration.asHours()

          finalHours += dur
        }
      }
      // this.totalHoursWorkedSumWeekly =  moment().startOf('day').add(finalHours, 'hours').format('H:mm') // finalHours.toFixed(1)// moment().startOf('day').add(finalHours, 'hours').format('HH:mm');
      this.totalHoursWorkedSumWeekly = this.FormatHours(finalHours)
    },
    FormatHours(hours) {
        let totalMinutes = Math.round(hours * 60)
        let hh = Math.floor(totalMinutes / 60)
        let mm = totalMinutes % 60
        return `${hh}:${mm.toString().padStart(2, '0')}`
    },
    UpdatePieChart() {
      if (this.clientList == null) return
      //var hours = [.01]
      //var labels = ["Hours Remaining"]
      //var colors = ["7961F911"]
      const hours = []
      const labels = []
      const colors = []
      let rand = 0

      let addedCurrentTimeEntry = false

      let totalHoursRemaining = 0

      if (this.rawTotalHoursWorked.length > 0) {
        totalHoursRemaining = this.rawTotalHoursWorked[0].DailyTimeGoal
      }

      for (let i = 0; i < this.rawTotalHoursWorked.length; i++) {
        //hours[0] = this.rawTotalHoursWorked[i].DailyTimeGoal
        var el = this.rawTotalHoursWorked[i]
        let h = el.HoursWorked || 0
        
        totalHoursRemaining -= el.HoursWorked
        if (totalHoursRemaining < 0) {
          totalHoursRemaining = 0
        }

        const client = this.clientList.find(x => x.ClientID === el.ClientID)
        if (client != null) {
          labels.push(client.ClientName)
          let graphColor2 = client.GraphColor
          if (graphColor2 == null) {
            graphColor2 = this.GetRandomGraphColor(rand)
            rand++
          }
          colors.push(graphColor2)

          hours.push(h)
        }
      }
      if (addedCurrentTimeEntry === false) {
        if (this.currentTimeEntry != null) {
          if (this.currentTimeEntry.ClientID != null) {
            var f = 'YYYY-MM-DD hh:mm A'
            var duration = moment.duration(moment().diff(moment(moment.utc(this.currentTimeEntry.TimeIn, f).toDate())))
            var dur = duration.asHours()
            totalHoursRemaining -= dur            
            hours.push(dur)
            labels.push('In-Progress')
            let graphColor = '#fff'
            colors.push(graphColor)
          }
        }
      }

      hours.push(totalHoursRemaining)
      labels.push('Hours Remaining')
      colors.push('7961F911')
      
      Vue.delete(this.donutChart.chartOptions, 'labels')
      Vue.delete(this.donutChart.chartOptions, 'colors')

      this.donutChart.chartOptions.labels = labels
      this.donutChart.chartOptions.colors = colors

      this.donutChartSeries = hours
    },

    UpdatePieChartBillable() {
      if (this.billableWeeklyWorked.TotalHours == null) return

      Vue.delete(this.donutChartBillable.chartOptions, 'labels')
      Vue.delete(this.donutChartBillable.chartOptions, 'colors')

      let percentBillable = this.billableWeeklyWorked.PercentBillable
      let percentGoal = this.billableWeeklyWorked.BillablePercentGoal
      let billedHours = this.billableWeeklyWorked.BilledHours
      let totalHours = this.billableWeeklyWorked.TotalHours

      // percentBillable = .75
      // billedHours = 75
      // totalHours = 100
      // percentGoal = .5

      const dif = percentBillable - percentGoal
      const difHours = dif * totalHours
      if (dif > 0) {
        this.overBillable = true
        this.donutChartBillable.chartOptions.labels = ['Billable', 'Over', 'Unbillable']
        this.donutChartBillable.chartOptions.colors = ['#99ff9999', '#22ff22', '#7961F911']
        this.donutChartSeriesBillable = [
          billedHours - difHours,
          Math.abs(difHours),
          totalHours - billedHours
        ]
      } else {
        this.overBillable = false
        this.donutChartBillable.chartOptions.labels = ['Billable', 'Under', 'Unbillable']
        this.donutChartBillable.chartOptions.colors = ['#99ff9999', '#ff5555', '#ff5555']
        this.donutChartSeriesBillable = [
          billedHours,
          Math.abs(difHours),
          totalHours - billedHours + difHours
        ]
      }

      /*  totalhours = 100
          BillableHours = 80
          PercentBillable = .8
          Target: .7
      */

      

      console.log(this.donutChartSeriesBillable)
    },

    UpdatePieChartWeekly() {
      if (this.clientList == null) return
      //var hours = [.01]
      //var labels = ["Hours Remaining"]
      //var colors = ["7961F911"]
      const hours = []
      const labels = []
      const colors = []
      let rand = 0

      let addedCurrentTimeEntry = false

      let totalHoursRemaining = 0

      if (this.rawTotalHoursWorkedWeekly.length > 0) {
        totalHoursRemaining = this.rawTotalHoursWorkedWeekly[0].DailyTimeGoal * 5
      }
      for (let i = 0; i < this.rawTotalHoursWorkedWeekly.length; i++) {
        var el = this.rawTotalHoursWorkedWeekly[i]
        let h = el.HoursWorked || 0
        
        totalHoursRemaining -= el.HoursWorked

        if (totalHoursRemaining < 0) {
          totalHoursRemaining = 0
        }

        const client = this.clientList.find(x => x.ClientID == el.ClientID)
        if (client != null) {
          labels.push(client.ClientName)
          let graphColor2 = client.GraphColor
          if (graphColor2 == null) {
            graphColor2 = this.GetRandomGraphColor(rand)
            rand++
          }
          colors.push(graphColor2)

          hours.push(h)
        }
      }

      if (addedCurrentTimeEntry === false) {
        if (this.currentTimeEntry != null) {
          if (this.currentTimeEntry.ClientID != null) {
            var f = 'YYYY-MM-DD hh:mm A'
            var duration = moment.duration(moment().diff(moment(moment.utc(this.currentTimeEntry.TimeIn, f).toDate())))
            var dur = duration.asHours()
            totalHoursRemaining -= dur            
            hours.push(dur)
            labels.push('In-Progress')
            let graphColor = '#fff'
            colors.push(graphColor)
          }
        }
      }


      hours.push(totalHoursRemaining)
      labels.push('Hours Remaining')
      colors.push('7961F911')
      
      Vue.delete(this.donutChartWeekly.chartOptions, 'labels')
      Vue.delete(this.donutChartWeekly.chartOptions, 'colors')

      this.donutChartWeekly.chartOptions.labels = labels
      this.donutChartWeekly.chartOptions.colors = colors

      this.donutChartSeriesWeekly = hours
    },
    GetRandomGraphColor (i) {
      const defaultColors = ['#FF9F43', '#EA5455', '#827191', '#84ACCE', '#7D1D3F']
      return defaultColors[i]
    },
    
    OnClickClockOut () {

      console.log('current task', this.currentTimeEntryTask)
      console.log('sow list', this.sowList)
      const currentTime = moment().format('hh:mm A')
      const currentDate = moment().format('Y-MM-DD')
      // const task = this.taskListAll.find(x => x.id == this.currentTimeEntry.JiraIssueID)
      //this.ShowClockOutPrompt()
      let sow
      if (this.currentTimeEntryTask != null) {
        sow = this.sowList.find(x => x.SOWID == this.currentTimeEntryTask.SOWID)
      }

      let categoryId = null
      if (sow != null) {
        categoryId = sow.CategoryID
      }

      let jiraIssueId = null
      if (this.currentTimeEntryTask != null && this.currentTimeEntryTask.id != null) {
        jiraIssueId = this.currentTimeEntryTask.id
      }

      this.$store.dispatch('ActionSetTimeEntryPrompt', {
        active: true,
        action: 'clockout',
        title:'Clock Out',
        jiraIssueID: jiraIssueId,
        taskID: this.currentTimeEntry.TaskID,
        sowLineItemID: this.currentTimeEntry.SOWLineItemID,
        description: this.currentTimeEntry.Note,
        startTime: moment(moment.utc(this.currentTimeEntry.TimeIn).toDate(), 'YYYY-MM-DD hh:mm A').format('hh:mm A'),
        startDate: moment(moment.utc(this.currentTimeEntry.TimeIn).toDate(), 'YYYY-MM-DD hh:mm A').format('Y-MM-DD'),
        endTime: currentTime,
        endDate: currentDate,
        timeIn: this.currentTimeEntry.TimeIn,
        timeOut: moment().format('YYYY-MM-DD hh:mm A'),
        clientCategory: this.currentTimeEntry.CategoryName,
        clientID: this.currentTimeEntry.ClientID,
        projectID: this.currentTimeEntry.ProjectID,
        // categoryID: categoryId,
        categoryID: this.currentTimeEntry.CategoryID,
        clientName: this.currentTimeEntry.ClientName,
        recordID: this.currentTimeEntry.RecordID,
        task: this.currentTimeEntryTask,
        mileage: this.currentTimeEntry.Mileage,
        sowID: this.currentTimeEntry.SOWID,
        sowLineItemID: this.currentTimeEntry.SOWLineItemID,

      })
    },
    BeginPolling () {
      this.GetTotalHoursWorkedSum()
      this.GetTotalHoursWorkedSumWeekly()
      this.UpdatePieChart()
      this.UpdatePieChartWeekly()
      this.UpdatePieChartBillable()
      clearInterval(this.polling1)
      clearInterval(this.polling2)
      this.polling1 = setInterval(() => {
        this.GetTotalHoursWorkedSum()
        this.GetTotalHoursWorkedSumWeekly()
      }, 10000)
      this.polling2 = setInterval(() => {
        this.UpdatePieChart()
        this.UpdatePieChartWeekly()
        this.UpdatePieChartBillable()
      }, 30000)
    },
    HexToRGB(h) {
      let r = 0, g = 0, b = 0;

      // 3 digits
      if (h.length == 4) {
        r = "0x" + h[1] + h[1];
        g = "0x" + h[2] + h[2];
        b = "0x" + h[3] + h[3];

      // 6 digits
      } else if (h.length == 7) {
        r = "0x" + h[1] + h[2];
        g = "0x" + h[3] + h[4];
        b = "0x" + h[5] + h[6];
      }
      return {
        r: parseInt(r, 16),
        g: parseInt(g, 16),
        b: parseInt(b, 16),
      }
    },
    RGBToHex(r,g,b) {
      r = r.toString(16).split('.')[0]
      g = g.toString(16).split('.')[0]
      b = b.toString(16).split('.')[0]

      if (r.length == 1)
        r = "0" + r;
      if (g.length == 1)
        g = "0" + g;
      if (b.length == 1)
        b = "0" + b;
      return "#" + r + g + b;
    },
    Lerp(a, b, t)
    {
        return a * (1 - t) + b * t;
    },
    LerpColor (a, b, amount) { 
      const rgb1 = this.HexToRGB(a)
      const rgb2 = this.HexToRGB(b)
      rgb1.r = this.Lerp(rgb1.r, rgb2.r, amount)
      rgb1.g = this.Lerp(rgb1.g, rgb2.g, amount)
      rgb1.b = this.Lerp(rgb1.b, rgb2.b, amount)

      return this.RGBToHex(rgb1.r, rgb1.g, rgb1.b)
    },
  },
  mounted() {
    clearInterval(this.subEntryCounting)
    let t = this
    this.subEntryCounting = setInterval(() => {
      t.SubEntryTick()
      
    }, 1000)
  }
}
</script>

<style lang="css">
.m-tiny {
  margin: 1px;
}

.pie-charts-holder {
  overflow: hidden;
  display: flex;
  overflow-x: auto;
  justify-content: space-between;
}

.pie-chart-col {
  width: 200px;
  /* padding-top: 20px; */
  justify-content: center;
  display: flex;
}

.mileage-ring-holder {
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translateY(12px);
}

.mileage-ring {
  width: 105px;
  height: 105px;
  border: 1px solid #ffffff55;
  border-radius: 100%;
}

</style>
